// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"219776d4","498":"4ff2d7c0","703":"aa9f3239"}[chunkId] + ".chunk.js";
};